import React from 'react';
import { Card, Stack, Text, Group, Badge, Divider } from '@mantine/core';
import { IconBuilding } from '@tabler/icons-react';
import type { CoursePlanBusinessUnit } from '../../../../types/lcms/coursePlan';

interface PlanBusinessUnitsSectionProps {
  businessUnits: CoursePlanBusinessUnit[];
}

const PlanBusinessUnitsSection: React.FC<PlanBusinessUnitsSectionProps> = ({ businessUnits }) => {
  if (!businessUnits || businessUnits.length === 0) {
    return (
      <Card>
        <Group gap={12} mb={16}>
          <IconBuilding size={20} />
          <Text fw={600} size='lg'>
            Business Units
          </Text>
        </Group>
        <Text c='dimmed' size='sm' style={{ fontStyle: 'italic' }}>
          No business units assigned to this course plan
        </Text>
      </Card>
    );
  }

  return (
    <Card>
      <Group gap={12} mb={16}>
        <IconBuilding size={20} />
        <Text fw={600} size='lg'>
          Business Units ({businessUnits.length})
        </Text>
      </Group>

      <Stack gap={12}>
        {businessUnits.map((item, index) => (
          <React.Fragment key={item.trLCMSPlanningBusinessUnitsID}>
            <Group justify='space-between' align='flex-start'>
              <Stack gap={4} flex={1}>
                <Text fw={500} size='sm'>
                  {item.businessUnitName}
                </Text>
                <Group gap={8}>
                  <Badge variant='light' size='xs' color='blue'>
                    {item.businessUnitID}
                  </Badge>
                </Group>
              </Stack>
            </Group>
            {index < businessUnits.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>
    </Card>
  );
};

export default PlanBusinessUnitsSection;
